import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Time: { input: any; output: any; }
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street1: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
};

export type Compound = Treatment & {
  __typename?: 'Compound';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Cost = {
  __typename?: 'Cost';
  amount?: Maybe<Scalars['Float']['output']>;
  amountTitle?: Maybe<Scalars['String']['output']>;
  promotions?: Maybe<Array<OfferPromotion>>;
  retailAmount?: Maybe<Scalars['Float']['output']>;
  retailAmountTitle?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type Customer = {
  __typename?: 'Customer';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DayOfWeek =
  | 'FRIDAY'
  | 'MONDAY'
  | 'SATURDAY'
  | 'SUNDAY'
  | 'THURSDAY'
  | 'TUESDAY'
  | 'WEDNESDAY';

export type DeliveryEstimate = {
  __typename?: 'DeliveryEstimate';
  deliveryPromise: Scalars['String']['output'];
  deliveryPromiseRangeEnd?: Maybe<Scalars['DateTime']['output']>;
  deliveryPromiseRangeStart?: Maybe<Scalars['DateTime']['output']>;
};

export type DiscountCard = {
  __typename?: 'DiscountCard';
  bin: Scalars['String']['output'];
  externalUrl?: Maybe<Scalars['String']['output']>;
  group: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  memberId: Scalars['String']['output'];
  orderId: Scalars['ID']['output'];
  pcn: Scalars['String']['output'];
  pharmacyId: Scalars['ID']['output'];
  prescriptionId: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  retailPrice?: Maybe<Scalars['Float']['output']>;
  source: Scalars['String']['output'];
};

export type Fill = {
  __typename?: 'Fill';
  filledAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  order: Order;
  prescription?: Maybe<Prescription>;
  requestedAt: Scalars['DateTime']['output'];
  state: FillState | `${FillState}`;
  treatment: Treatment;
};

export type FillState =
  | 'CANCELED'
  | 'NEW'
  | 'PROCESSING'
  | 'RECEIVED'
  | 'SCHEDULED'
  | 'SENT';

export type FulfillmentExceptionType =
  | 'BACKORDERED'
  | 'HIGH_COPAY'
  | 'MEDICAL_DEVICE'
  | 'NOT_COVERED'
  | 'OOS'
  | 'OTC'
  | 'PA_REQUIRED'
  | 'REFILL_TOO_SOON'
  | 'RX_CLARIFICATION';

export type FulfillmentType =
  | 'MAIL_ORDER'
  | 'PICK_UP';

export type Group = {
  __typename?: 'Group';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type LatLongSearch = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  /** Search radius in miles */
  radius?: InputMaybe<Scalars['Int']['input']>;
};

export type MedicalEquipment = Treatment & {
  __typename?: 'MedicalEquipment';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  names?: Maybe<MedicationNames>;
  therapeuticClassifications: Array<Maybe<TherapeuticClassificationChain>>;
};

export type Medication = Treatment & {
  __typename?: 'Medication';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  names?: Maybe<MedicationNames>;
  strength?: Maybe<Scalars['String']['output']>;
  therapeuticClassifications: Array<Maybe<TherapeuticClassificationChain>>;
};

export type MedicationNames = {
  __typename?: 'MedicationNames';
  brandName?: Maybe<Scalars['String']['output']>;
  genericName?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  markOrderAsPickedUp: Scalars['Boolean']['output'];
  rerouteOrder: Scalars['Boolean']['output'];
  selectOrderPharmacy: Scalars['Boolean']['output'];
  setOrderPharmacy: Scalars['Boolean']['output'];
  setPreferredPharmacy?: Maybe<Scalars['Boolean']['output']>;
  updateOrder?: Maybe<Order>;
  updatePatient?: Maybe<Patient>;
};


export type MutationMarkOrderAsPickedUpArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRerouteOrderArgs = {
  orderId: Scalars['ID']['input'];
  patientSelectedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  pharmacyId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSelectOrderPharmacyArgs = {
  orderId: Scalars['ID']['input'];
  patientId?: InputMaybe<Scalars['String']['input']>;
  pharmacyId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetOrderPharmacyArgs = {
  orderId: Scalars['ID']['input'];
  patientSelectedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  pharmacyId: Scalars['ID']['input'];
  readyBy?: InputMaybe<Scalars['String']['input']>;
  readyByDay?: InputMaybe<Scalars['String']['input']>;
  readyByTime?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationSetPreferredPharmacyArgs = {
  patientId?: InputMaybe<Scalars['String']['input']>;
  pharmacyId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateOrderArgs = {
  input: UpdateOrderInput;
  orderId: Scalars['ID']['input'];
};


export type MutationUpdatePatientArgs = {
  input: UpdatePatientInput;
  patientId: Scalars['ID']['input'];
};

export type Name = {
  __typename?: 'Name';
  first: Scalars['String']['output'];
  /** Convenience method for getting a formated name */
  full: Scalars['String']['output'];
  last: Scalars['String']['output'];
  middle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/**
 * This represents a single offer for a single prescription
 * and is deprecated in favor of OfferBundle which can
 * contain one or multiple medications.
 */
export type Offer = {
  __typename?: 'Offer';
  cost?: Maybe<Cost>;
  deliveryEstimate?: Maybe<DeliveryEstimate>;
  prescription?: Maybe<Prescription>;
  supplier: SupplierType | `${SupplierType}`;
};

/**
 * This represents an offer for multiple prescriptions
 * and is the new preferred way to represent offers,
 * eventually replacing Offer
 */
export type OfferBundle = {
  __typename?: 'OfferBundle';
  aggregateCost: OfferBundleAggregateCost;
  medications: Array<OfferMedication>;
  pricingType: Scalars['String']['output'];
  supplier: SupplierType | `${SupplierType}`;
};

export type OfferBundleAggregateCost = {
  __typename?: 'OfferBundleAggregateCost';
  medicationCount: Scalars['Int']['output'];
  totalAmount?: Maybe<Scalars['Float']['output']>;
  totalRetailAmount?: Maybe<Scalars['Float']['output']>;
};

export type OfferMedication = {
  __typename?: 'OfferMedication';
  deliveryEstimate?: Maybe<OfferMedicationDeliveryEstimate>;
  medicationPrice?: Maybe<OfferMedicationPrice>;
  prescription?: Maybe<Prescription>;
};

export type OfferMedicationDeliveryEstimate = {
  __typename?: 'OfferMedicationDeliveryEstimate';
  deliveryPromise: Scalars['String']['output'];
};

export type OfferMedicationPrice = {
  __typename?: 'OfferMedicationPrice';
  amount?: Maybe<Scalars['Float']['output']>;
  amountTitle?: Maybe<Scalars['String']['output']>;
  promotions?: Maybe<Array<OfferPromotion>>;
  retailAmount?: Maybe<Scalars['Float']['output']>;
  retailAmountTitle?: Maybe<Scalars['String']['output']>;
};

export type OfferPromotion = {
  __typename?: 'OfferPromotion';
  amount?: Maybe<Scalars['Float']['output']>;
  amountSaved?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Order = {
  __typename?: 'Order';
  address?: Maybe<Address>;
  createdAt: Scalars['DateTime']['output'];
  discountCards: Array<DiscountCard>;
  exceptions: Array<OrderException>;
  externalId?: Maybe<Scalars['ID']['output']>;
  fills: Array<Fill>;
  fulfillment?: Maybe<OrderFulfillment>;
  fulfillments: Array<PrescriptionFulfillment>;
  group?: Maybe<Group>;
  id: Scalars['ID']['output'];
  isReroutable: Scalars['Boolean']['output'];
  metadata?: Maybe<OrderMetadata>;
  organization: Organization;
  patient: Patient;
  pharmacy?: Maybe<Pharmacy>;
  readyBy?: Maybe<Scalars['String']['output']>;
  readyByDay?: Maybe<Scalars['String']['output']>;
  readyByTime?: Maybe<Scalars['DateTime']['output']>;
  state: OrderState | `${OrderState}`;
};


export type OrderExceptionsArgs = {
  includeResolved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderException = {
  __typename?: 'OrderException';
  createdAt: Scalars['DateTime']['output'];
  exceptionType: OrderExceptionType | `${OrderExceptionType}`;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderExceptionType =
  | 'DEMOGRAPHIC_MISMATCH'
  | 'DOCTOR_NOT_LICENSED_IN_STATE'
  | 'EXTERNAL_TRANSFER'
  | 'ORDER_ERROR'
  | 'PHARMACY_CLOSED'
  | 'PHARMACY_DOES_NOT_ACCEPT_INSURANCE'
  | 'PHARMACY_NEEDS_INSURANCE_INFO'
  | 'PHARMACY_UNREACHABLE'
  | 'SUPERVISING_PHYSICIAN_NEEDED';

export type OrderFulfillment = {
  __typename?: 'OrderFulfillment';
  carrier?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  minutesUntilReady?: Maybe<Scalars['Int']['output']>;
  pharmacyEstimatedReadyAt?: Maybe<Scalars['DateTime']['output']>;
  state: Scalars['String']['output'];
  trackingNumber?: Maybe<Scalars['String']['output']>;
  type: FulfillmentType | `${FulfillmentType}`;
};

export type OrderMetadata = {
  __typename?: 'OrderMetadata';
  fulfillmentMethod?: Maybe<Scalars['String']['output']>;
  marketIsRequired?: Maybe<Scalars['Boolean']['output']>;
  routingHistory: Array<Maybe<OrderRoutingHistory>>;
  transmissionType?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type OrderRoutingHistory = {
  __typename?: 'OrderRoutingHistory';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  pharmacy?: Maybe<Pharmacy>;
  reason?: Maybe<Scalars['String']['output']>;
  selector?: Maybe<Scalars['String']['output']>;
};

export type OrderState =
  | 'CANCELED'
  | 'COMPLETED'
  | 'ERROR'
  | 'PENDING'
  | 'PLACED'
  | 'ROUTING';

export type Organization = {
  __typename?: 'Organization';
  customer?: Maybe<Customer>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  settings?: Maybe<OrganizationSettings>;
};

export type OrganizationPatientUxSettings = {
  __typename?: 'OrganizationPatientUxSettings';
  enableAutomatedOps?: Maybe<Scalars['Boolean']['output']>;
  enablePatientDeliveryPharmacies?: Maybe<Scalars['Boolean']['output']>;
  enablePatientRerouting?: Maybe<Scalars['Boolean']['output']>;
  patientFeaturedPharmacyName?: Maybe<Scalars['String']['output']>;
};

export type OrganizationSettings = {
  __typename?: 'OrganizationSettings';
  brandColor: Scalars['String']['output'];
  brandLogo?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  patientUx: OrganizationPatientUxSettings;
  priorAuthorizationExceptionMessage?: Maybe<Scalars['String']['output']>;
};

export type Patient = {
  __typename?: 'Patient';
  address?: Maybe<Address>;
  dateOfBirth: Scalars['Date']['output'];
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Name;
  phone: Scalars['String']['output'];
  preferredPharmacies: Array<Pharmacy>;
  sex: SexType | `${SexType}`;
};

export type PatientProvider = {
  __typename?: 'PatientProvider';
  id: Scalars['ID']['output'];
  name?: Maybe<Name>;
};

export type Pharmacy = {
  __typename?: 'Pharmacy';
  address?: Maybe<Address>;
  distance?: Maybe<Scalars['Float']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  fulfillmentTypes?: Maybe<Array<FulfillmentType | `${FulfillmentType}`>>;
  /**
   * Hours information for the Pharmacy.
   * Empty if we don't have the relevant data
   */
  hours?: Maybe<Array<PharmacyHours>>;
  id: Scalars['ID']['output'];
  integrated?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Returns true if the pharmacy is open at time `at`.
   * Returns false if the pharmacy is closed at time `at`
   * Returns null if we don't have the relevant data
   *
   * `isOpen` with no argument is assumed to be the same as `isOpen(now)` using the server's clock
   */
  isOpen?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /**
   * Returns next open and close events relative to `at`
   * Returns null if we don't have relevant data
   * If 24hr pharmacy, then returns a PharmacyOpen24HrEvent for both open and close
   *
   * If the pharmacy is open (and is not 24hr), the close value will be prior to the open
   * If the pharmacy is closed, the open value will be prior to the close
   *
   * Beware timezone issues! The dates are returned serialized. Convert them to local timezone before using
   */
  nextEvents?: Maybe<PharmacyEvents>;
  npi?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  /** The price of the medication at this pharmacy */
  price?: Maybe<Scalars['Float']['output']>;
  /** The non-discounted the medication at this pharmacy if available */
  retailPrice?: Maybe<Scalars['Float']['output']>;
  /** The source of the price. Either GoodRx or RxSense. */
  source?: Maybe<Scalars['String']['output']>;
};


export type PharmacyIsOpenArgs = {
  at?: InputMaybe<Scalars['DateTime']['input']>;
};


export type PharmacyNextEventsArgs = {
  at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PharmacyCloseEvent = {
  __typename?: 'PharmacyCloseEvent';
  datetime: Scalars['DateTime']['output'];
  type: Scalars['String']['output'];
};

export type PharmacyEvent = PharmacyCloseEvent | PharmacyOpen24HrEvent | PharmacyOpenEvent;

export type PharmacyEvents = {
  __typename?: 'PharmacyEvents';
  close: PharmacyEvent;
  open: PharmacyEvent;
};

export type PharmacyHours = {
  __typename?: 'PharmacyHours';
  /** Day of the week this hours block applies to */
  dayOfWeek: DayOfWeek | `${DayOfWeek}`;
  /**
   * True if its open 24 hours on this day, false otherwise
   * If True, openFrom will be "00:00" and openUntil will be "23:59"
   */
  is24Hr: Scalars['Boolean']['output'];
  /** A string representing the time, in 24 hour HH:MM format */
  openFrom: Scalars['String']['output'];
  /** A string representing the time, in 24 hour HH:MM format */
  openUntil: Scalars['String']['output'];
  /**
   * An IANA string representing the local timezone of the pharmacy.
   * All hours are given local to the pharmacy
   */
  timezone: Scalars['String']['output'];
};

export type PharmacyOpen24HrEvent = {
  __typename?: 'PharmacyOpen24HrEvent';
  type: Scalars['String']['output'];
};

export type PharmacyOpenEvent = {
  __typename?: 'PharmacyOpenEvent';
  datetime: Scalars['DateTime']['output'];
  type: Scalars['String']['output'];
};

export type Prescription = {
  __typename?: 'Prescription';
  daysSupply?: Maybe<Scalars['Int']['output']>;
  dispenseAsWritten: Scalars['Boolean']['output'];
  dispenseQuantity: Scalars['Float']['output'];
  dispenseUnit: Scalars['String']['output'];
  doNotFillBeforeDate?: Maybe<Scalars['Date']['output']>;
  effectiveDate: Scalars['Date']['output'];
  expirationDate: Scalars['Date']['output'];
  fills: Array<Maybe<Fill>>;
  fillsAllowed: Scalars['Int']['output'];
  fillsRemaining: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  instructions: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<PatientProvider>;
  treatment: Treatment;
  writtenAt: Scalars['DateTime']['output'];
};

export type PrescriptionFulfillment = {
  __typename?: 'PrescriptionFulfillment';
  carrier?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  exceptions: Array<PrescriptionFulfillmentException>;
  fulfillmentType?: Maybe<FulfillmentType | `${FulfillmentType}`>;
  id: Scalars['ID']['output'];
  orderId: Scalars['ID']['output'];
  patientDesiredAt?: Maybe<Scalars['DateTime']['output']>;
  patientDesiredByDay?: Maybe<Scalars['String']['output']>;
  patientDesiredByText?: Maybe<Scalars['String']['output']>;
  pharmacyEstimatedReadyAt?: Maybe<Scalars['DateTime']['output']>;
  pharmacyId?: Maybe<Scalars['ID']['output']>;
  prescription: Prescription;
  state: PrescriptionFulfillmentState | `${PrescriptionFulfillmentState}`;
};


export type PrescriptionFulfillmentExceptionsArgs = {
  includeResolved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrescriptionFulfillmentException = {
  __typename?: 'PrescriptionFulfillmentException';
  createdAt: Scalars['DateTime']['output'];
  exceptionType: FulfillmentExceptionType | `${FulfillmentExceptionType}`;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PrescriptionFulfillmentState =
  | 'CREATED'
  | 'DELIVERED'
  | 'PICKED_UP'
  | 'PROCESSING'
  | 'READY'
  | 'RECEIVED'
  | 'SENT';

export type Query = {
  __typename?: 'Query';
  me?: Maybe<Patient>;
  offerBundles: Array<OfferBundle>;
  offers: Array<Offer>;
  order?: Maybe<Order>;
  organization?: Maybe<Organization>;
  pharmacies: Array<Pharmacy>;
  pharmaciesByLocation: Array<Pharmacy>;
  pharmacy: Pharmacy;
};


export type QueryOfferBundlesArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryOffersArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPharmaciesArgs = {
  fulfillmentType?: InputMaybe<FulfillmentType>;
  integrated?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPharmaciesByLocationArgs = {
  includePrice?: InputMaybe<Scalars['Boolean']['input']>;
  is24hr?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  location: LatLongSearch;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openAt?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryPharmacyArgs = {
  id: Scalars['ID']['input'];
};

export type SexType =
  | 'FEMALE'
  | 'MALE'
  | 'UNKNOWN';

export type SupplierType =
  | 'AMAZON_PHARMACY'
  | 'UNKNOWN';

export type TherapeuticClassificationChain = {
  __typename?: 'TherapeuticClassificationChain';
  tc0?: Maybe<TherapeuticClassificationEntry>;
  tc2?: Maybe<TherapeuticClassificationEntry>;
  tc4?: Maybe<TherapeuticClassificationEntry>;
  tc6?: Maybe<TherapeuticClassificationEntry>;
  tc10?: Maybe<TherapeuticClassificationEntry>;
};

export type TherapeuticClassificationEntry = {
  __typename?: 'TherapeuticClassificationEntry';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Treatment = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UpdateOrderInput = {
  addressId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePatientInput = {
  address?: InputMaybe<AddressInput>;
};

export type MarkOrderAsPickedUpMutationVariables = Exact<{
  markOrderAsPickedUpId: Scalars['ID']['input'];
}>;


export type MarkOrderAsPickedUpMutation = { __typename?: 'Mutation', markOrderAsPickedUp: boolean };

export type SetPreferredPharmacyMutationVariables = Exact<{
  pharmacyId?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetPreferredPharmacyMutation = { __typename?: 'Mutation', setPreferredPharmacy?: boolean | undefined };

export type RerouteOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  pharmacyId: Scalars['ID']['input'];
  patientSelectedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type RerouteOrderMutation = { __typename?: 'Mutation', rerouteOrder: boolean };

export type SetOrderPharmacyMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  pharmacyId: Scalars['ID']['input'];
  readyBy?: InputMaybe<Scalars['String']['input']>;
  readyByDay?: InputMaybe<Scalars['String']['input']>;
  readyByTime?: InputMaybe<Scalars['DateTime']['input']>;
  patientSelectedPrice?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetOrderPharmacyMutation = { __typename?: 'Mutation', setOrderPharmacy: boolean };

export type UpdatePatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  input: UpdatePatientInput;
}>;


export type UpdatePatientMutation = { __typename?: 'Mutation', updatePatient?: { __typename?: 'Patient', id: string, address?: { __typename?: 'Address', id?: string | undefined, street1: string, street2?: string | undefined, city: string, state: string, postalCode: string, country: string } | undefined } | undefined };

export type UpdateOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  input: UpdateOrderInput;
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', updateOrder?: { __typename?: 'Order', id: string, address?: { __typename?: 'Address', id?: string | undefined, street1: string, street2?: string | undefined, city: string, state: string, postalCode: string, country: string } | undefined } | undefined };

export type GetOrderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  openAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetOrderQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, state: OrderState, isReroutable: boolean, readyBy?: string | undefined, readyByTime?: any | undefined, readyByDay?: string | undefined, address?: { __typename?: 'Address', id?: string | undefined, street1: string, street2?: string | undefined, city: string, state: string, country: string, postalCode: string } | undefined, group?: { __typename?: 'Group', id: string, name: string } | undefined, metadata?: { __typename?: 'OrderMetadata', type?: string | undefined, marketIsRequired?: boolean | undefined, fulfillmentMethod?: string | undefined, transmissionType?: string | undefined, routingHistory: Array<{ __typename?: 'OrderRoutingHistory', selector?: string | undefined, createdAt?: any | undefined, reason?: string | undefined, pharmacy?: { __typename?: 'Pharmacy', id: string, name: string } | undefined } | undefined> } | undefined, organization: { __typename?: 'Organization', id: string, name: string, settings?: { __typename?: 'OrganizationSettings', brandColor: string, brandLogo?: string | undefined, priorAuthorizationExceptionMessage?: string | undefined, patientUx: { __typename?: 'OrganizationPatientUxSettings', enableAutomatedOps?: boolean | undefined, enablePatientRerouting?: boolean | undefined, enablePatientDeliveryPharmacies?: boolean | undefined, patientFeaturedPharmacyName?: string | undefined } } | undefined, customer?: { __typename?: 'Customer', id: string, name: string } | undefined }, fulfillment?: { __typename?: 'OrderFulfillment', type: FulfillmentType, state: string, carrier?: string | undefined, trackingNumber?: string | undefined, pharmacyEstimatedReadyAt?: any | undefined } | undefined, exceptions: Array<{ __typename?: 'OrderException', exceptionType: OrderExceptionType, message?: string | undefined, resolvedAt?: any | undefined }>, pharmacy?: { __typename?: 'Pharmacy', id: string, name: string, logo?: string | undefined, integrated?: boolean | undefined, fulfillmentTypes?: Array<FulfillmentType> | undefined, phone?: string | undefined, isOpen?: boolean | undefined, address?: { __typename?: 'Address', street1: string, street2?: string | undefined, city: string, state: string, country: string, postalCode: string } | undefined, nextEvents?: { __typename?: 'PharmacyEvents', open: { __typename?: 'PharmacyCloseEvent', type: string, datetime: any } | { __typename?: 'PharmacyOpen24HrEvent', type: string } | { __typename?: 'PharmacyOpenEvent', type: string, datetime: any }, close: { __typename?: 'PharmacyCloseEvent', type: string, datetime: any } | { __typename?: 'PharmacyOpen24HrEvent', type: string } | { __typename?: 'PharmacyOpenEvent', type: string, datetime: any } } | undefined, hours?: Array<{ __typename?: 'PharmacyHours', dayOfWeek: DayOfWeek, is24Hr: boolean, openFrom: string, openUntil: string, timezone: string }> | undefined } | undefined, fills: Array<{ __typename?: 'Fill', id: string, treatment: { __typename?: 'Compound', id: string, name: string } | { __typename?: 'MedicalEquipment', id: string, name: string, names?: { __typename?: 'MedicationNames', brandName?: string | undefined, genericName?: string | undefined } | undefined, therapeuticClassifications: Array<{ __typename?: 'TherapeuticClassificationChain', tc0?: { __typename?: 'TherapeuticClassificationEntry', code: string, name: string } | undefined, tc10?: { __typename?: 'TherapeuticClassificationEntry', name: string, code: string } | undefined, tc6?: { __typename?: 'TherapeuticClassificationEntry', name: string, code: string } | undefined, tc4?: { __typename?: 'TherapeuticClassificationEntry', name: string, code: string } | undefined, tc2?: { __typename?: 'TherapeuticClassificationEntry', name: string, code: string } | undefined } | undefined> } | { __typename?: 'Medication', id: string, name: string, strength?: string | undefined, names?: { __typename?: 'MedicationNames', brandName?: string | undefined, genericName?: string | undefined } | undefined, therapeuticClassifications: Array<{ __typename?: 'TherapeuticClassificationChain', tc0?: { __typename?: 'TherapeuticClassificationEntry', code: string, name: string } | undefined, tc10?: { __typename?: 'TherapeuticClassificationEntry', name: string, code: string } | undefined, tc6?: { __typename?: 'TherapeuticClassificationEntry', name: string, code: string } | undefined, tc4?: { __typename?: 'TherapeuticClassificationEntry', name: string, code: string } | undefined, tc2?: { __typename?: 'TherapeuticClassificationEntry', name: string, code: string } | undefined } | undefined> }, prescription?: { __typename?: 'Prescription', id: string, daysSupply?: number | undefined, dispenseQuantity: number, dispenseUnit: string, dispenseAsWritten: boolean, expirationDate: any, fillsAllowed: number, provider?: { __typename?: 'PatientProvider', id: string, name?: { __typename?: 'Name', full: string } | undefined } | undefined } | undefined }>, patient: { __typename?: 'Patient', id: string, dateOfBirth: any, gender?: string | undefined, sex: SexType, name: { __typename?: 'Name', full: string }, address?: { __typename?: 'Address', id?: string | undefined, street1: string, street2?: string | undefined, city: string, state: string, postalCode: string, country: string } | undefined, preferredPharmacies: Array<{ __typename?: 'Pharmacy', id: string, name: string, logo?: string | undefined, phone?: string | undefined, fulfillmentTypes?: Array<FulfillmentType> | undefined, integrated?: boolean | undefined, distance?: number | undefined, isOpen?: boolean | undefined, price?: number | undefined, retailPrice?: number | undefined, source?: string | undefined, address?: { __typename?: 'Address', street1: string, street2?: string | undefined, city: string, state: string, country: string, postalCode: string } | undefined, nextEvents?: { __typename?: 'PharmacyEvents', open: { __typename?: 'PharmacyCloseEvent', type: string, datetime: any } | { __typename?: 'PharmacyOpen24HrEvent', type: string } | { __typename?: 'PharmacyOpenEvent', type: string, datetime: any }, close: { __typename?: 'PharmacyCloseEvent', type: string, datetime: any } | { __typename?: 'PharmacyOpen24HrEvent', type: string } | { __typename?: 'PharmacyOpenEvent', type: string, datetime: any } } | undefined, hours?: Array<{ __typename?: 'PharmacyHours', dayOfWeek: DayOfWeek, is24Hr: boolean, openFrom: string, openUntil: string, timezone: string }> | undefined }> }, fulfillments: Array<{ __typename?: 'PrescriptionFulfillment', id: string, state: PrescriptionFulfillmentState, patientDesiredAt?: any | undefined, patientDesiredByText?: string | undefined, pharmacyEstimatedReadyAt?: any | undefined, exceptions: Array<{ __typename?: 'PrescriptionFulfillmentException', exceptionType: FulfillmentExceptionType, message?: string | undefined, resolvedAt?: any | undefined }>, prescription: { __typename?: 'Prescription', id: string, daysSupply?: number | undefined, dispenseQuantity: number, dispenseUnit: string, expirationDate: any, fillsAllowed: number, treatment: { __typename?: 'Compound', id: string, name: string } | { __typename?: 'MedicalEquipment', id: string, name: string } | { __typename?: 'Medication', id: string, name: string, strength?: string | undefined } } }>, discountCards: Array<{ __typename?: 'DiscountCard', id: string, prescriptionId: string, price: number, retailPrice?: number | undefined, bin: string, pcn: string, group: string, memberId: string, pharmacyId: string, source: string, externalUrl?: string | undefined }> } | undefined };

export type PharmacyFieldsFragment = { __typename?: 'Pharmacy', id: string, name: string, logo?: string | undefined, phone?: string | undefined, fulfillmentTypes?: Array<FulfillmentType> | undefined, integrated?: boolean | undefined, distance?: number | undefined, isOpen?: boolean | undefined, price?: number | undefined, retailPrice?: number | undefined, source?: string | undefined, address?: { __typename?: 'Address', street1: string, street2?: string | undefined, city: string, state: string, country: string, postalCode: string } | undefined, nextEvents?: { __typename?: 'PharmacyEvents', open: { __typename?: 'PharmacyCloseEvent', type: string, datetime: any } | { __typename?: 'PharmacyOpen24HrEvent', type: string } | { __typename?: 'PharmacyOpenEvent', type: string, datetime: any }, close: { __typename?: 'PharmacyCloseEvent', type: string, datetime: any } | { __typename?: 'PharmacyOpen24HrEvent', type: string } | { __typename?: 'PharmacyOpenEvent', type: string, datetime: any } } | undefined, hours?: Array<{ __typename?: 'PharmacyHours', dayOfWeek: DayOfWeek, is24Hr: boolean, openFrom: string, openUntil: string, timezone: string }> | undefined };

export type GetPharmaciesByLocationQueryVariables = Exact<{
  location: LatLongSearch;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openAt?: InputMaybe<Scalars['DateTime']['input']>;
  is24hr?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  includePrice?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPharmaciesByLocationQuery = { __typename?: 'Query', pharmaciesByLocation: Array<{ __typename?: 'Pharmacy', id: string, name: string, logo?: string | undefined, phone?: string | undefined, fulfillmentTypes?: Array<FulfillmentType> | undefined, integrated?: boolean | undefined, distance?: number | undefined, isOpen?: boolean | undefined, price?: number | undefined, retailPrice?: number | undefined, source?: string | undefined, address?: { __typename?: 'Address', street1: string, street2?: string | undefined, city: string, state: string, country: string, postalCode: string } | undefined, nextEvents?: { __typename?: 'PharmacyEvents', open: { __typename?: 'PharmacyCloseEvent', type: string, datetime: any } | { __typename?: 'PharmacyOpen24HrEvent', type: string } | { __typename?: 'PharmacyOpenEvent', type: string, datetime: any }, close: { __typename?: 'PharmacyCloseEvent', type: string, datetime: any } | { __typename?: 'PharmacyOpen24HrEvent', type: string } | { __typename?: 'PharmacyOpenEvent', type: string, datetime: any } } | undefined, hours?: Array<{ __typename?: 'PharmacyHours', dayOfWeek: DayOfWeek, is24Hr: boolean, openFrom: string, openUntil: string, timezone: string }> | undefined }> };

export type GetPharmaciesQueryVariables = Exact<{
  fulfillmentType?: InputMaybe<FulfillmentType>;
  integrated?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPharmaciesQuery = { __typename?: 'Query', pharmacies: Array<{ __typename?: 'Pharmacy', id: string, name: string, logo?: string | undefined, fulfillmentTypes?: Array<FulfillmentType> | undefined }> };

export type GetInfoPageDataQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  pharmacyId: Scalars['ID']['input'];
  openAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetInfoPageDataQuery = { __typename?: 'Query', me?: { __typename?: 'Patient', name: { __typename?: 'Name', full: string, title?: string | undefined, first: string, middle?: string | undefined, last: string } } | undefined, organization?: { __typename?: 'Organization', id: string, name: string, settings?: { __typename?: 'OrganizationSettings', id: string, organizationId: string, brandColor: string, brandLogo?: string | undefined, priorAuthorizationExceptionMessage?: string | undefined, patientUx: { __typename?: 'OrganizationPatientUxSettings', enableAutomatedOps?: boolean | undefined, enablePatientRerouting?: boolean | undefined, enablePatientDeliveryPharmacies?: boolean | undefined, patientFeaturedPharmacyName?: string | undefined } } | undefined } | undefined, pharmacy: { __typename?: 'Pharmacy', id: string, name: string, logo?: string | undefined, phone?: string | undefined, fulfillmentTypes?: Array<FulfillmentType> | undefined, integrated?: boolean | undefined, distance?: number | undefined, isOpen?: boolean | undefined, price?: number | undefined, retailPrice?: number | undefined, source?: string | undefined, address?: { __typename?: 'Address', street1: string, street2?: string | undefined, city: string, state: string, country: string, postalCode: string } | undefined, nextEvents?: { __typename?: 'PharmacyEvents', open: { __typename?: 'PharmacyCloseEvent', type: string, datetime: any } | { __typename?: 'PharmacyOpen24HrEvent', type: string } | { __typename?: 'PharmacyOpenEvent', type: string, datetime: any }, close: { __typename?: 'PharmacyCloseEvent', type: string, datetime: any } | { __typename?: 'PharmacyOpen24HrEvent', type: string } | { __typename?: 'PharmacyOpenEvent', type: string, datetime: any } } | undefined, hours?: Array<{ __typename?: 'PharmacyHours', dayOfWeek: DayOfWeek, is24Hr: boolean, openFrom: string, openUntil: string, timezone: string }> | undefined } };

export type GetOffersForOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type GetOffersForOrderQuery = { __typename?: 'Query', offers: Array<{ __typename?: 'Offer', supplier: SupplierType, deliveryEstimate?: { __typename?: 'DeliveryEstimate', deliveryPromise: string, deliveryPromiseRangeEnd?: any | undefined, deliveryPromiseRangeStart?: any | undefined } | undefined, cost?: { __typename?: 'Cost', type: string, amount?: number | undefined, amountTitle?: string | undefined, retailAmount?: number | undefined, retailAmountTitle?: string | undefined } | undefined }> };

export type GetOfferBundlesForOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type GetOfferBundlesForOrderQuery = { __typename?: 'Query', offerBundles: Array<{ __typename?: 'OfferBundle', pricingType: string, supplier: SupplierType, aggregateCost: { __typename?: 'OfferBundleAggregateCost', totalAmount?: number | undefined, totalRetailAmount?: number | undefined }, medications: Array<{ __typename?: 'OfferMedication', medicationPrice?: { __typename?: 'OfferMedicationPrice', amount?: number | undefined, amountTitle?: string | undefined, retailAmount?: number | undefined, retailAmountTitle?: string | undefined, promotions?: Array<{ __typename?: 'OfferPromotion', type?: string | undefined, amount?: number | undefined, amountSaved?: number | undefined }> | undefined } | undefined, deliveryEstimate?: { __typename?: 'OfferMedicationDeliveryEstimate', deliveryPromise: string } | undefined, prescription?: { __typename?: 'Prescription', treatment: { __typename?: 'Compound', id: string, name: string } | { __typename?: 'MedicalEquipment', id: string, name: string } | { __typename?: 'Medication', id: string, name: string } } | undefined }> }> };

export const PharmacyFieldsFragmentDoc = gql`
    fragment PharmacyFields on Pharmacy {
  id
  name
  logo
  address {
    street1
    street2
    city
    state
    country
    postalCode
  }
  phone
  fulfillmentTypes
  integrated
  distance
  isOpen(at: $openAt)
  nextEvents(at: $openAt) {
    open {
      ... on PharmacyOpenEvent {
        type
        datetime
      }
      ... on PharmacyCloseEvent {
        type
        datetime
      }
      ... on PharmacyOpen24HrEvent {
        type
      }
    }
    close {
      ... on PharmacyOpenEvent {
        type
        datetime
      }
      ... on PharmacyCloseEvent {
        type
        datetime
      }
      ... on PharmacyOpen24HrEvent {
        type
      }
    }
  }
  hours {
    dayOfWeek
    is24Hr
    openFrom
    openUntil
    timezone
  }
  price
  retailPrice
  source
}
    `;
export const MarkOrderAsPickedUpDocument = gql`
    mutation MarkOrderAsPickedUp($markOrderAsPickedUpId: ID!) {
  markOrderAsPickedUp(id: $markOrderAsPickedUpId)
}
    `;
export const SetPreferredPharmacyDocument = gql`
    mutation SetPreferredPharmacy($pharmacyId: String, $patientId: String) {
  setPreferredPharmacy(pharmacyId: $pharmacyId, patientId: $patientId)
}
    `;
export const RerouteOrderDocument = gql`
    mutation RerouteOrder($orderId: ID!, $pharmacyId: ID!, $patientSelectedPrice: Boolean, $reason: String) {
  rerouteOrder(
    orderId: $orderId
    pharmacyId: $pharmacyId
    patientSelectedPrice: $patientSelectedPrice
    reason: $reason
  )
}
    `;
export const SetOrderPharmacyDocument = gql`
    mutation SetOrderPharmacy($orderId: ID!, $pharmacyId: ID!, $readyBy: String, $readyByDay: String, $readyByTime: DateTime, $patientSelectedPrice: Boolean) {
  setOrderPharmacy(
    orderId: $orderId
    pharmacyId: $pharmacyId
    readyBy: $readyBy
    readyByDay: $readyByDay
    readyByTime: $readyByTime
    patientSelectedPrice: $patientSelectedPrice
  )
}
    `;
export const UpdatePatientDocument = gql`
    mutation UpdatePatient($patientId: ID!, $input: UpdatePatientInput!) {
  updatePatient(patientId: $patientId, input: $input) {
    id
    address {
      id
      street1
      street2
      city
      state
      postalCode
      country
    }
  }
}
    `;
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($orderId: ID!, $input: UpdateOrderInput!) {
  updateOrder(orderId: $orderId, input: $input) {
    id
    address {
      id
      street1
      street2
      city
      state
      postalCode
      country
    }
  }
}
    `;
export const GetOrderDocument = gql`
    query GetOrder($id: ID!, $openAt: DateTime) {
  order(id: $id) {
    id
    state
    isReroutable
    readyBy
    readyByTime
    readyByDay
    address {
      id
      street1
      street2
      city
      state
      country
      postalCode
    }
    group {
      id
      name
    }
    metadata {
      type
      marketIsRequired
      fulfillmentMethod
      transmissionType
      routingHistory {
        pharmacy {
          id
          name
        }
        selector
        createdAt
        reason
      }
    }
    organization {
      id
      name
      settings {
        brandColor
        brandLogo
        priorAuthorizationExceptionMessage
        patientUx {
          enableAutomatedOps
          enablePatientRerouting
          enablePatientDeliveryPharmacies
          patientFeaturedPharmacyName
        }
      }
      customer {
        id
        name
      }
    }
    fulfillment {
      type
      state
      carrier
      trackingNumber
      pharmacyEstimatedReadyAt
    }
    exceptions {
      exceptionType
      message
      resolvedAt
    }
    pharmacy {
      id
      name
      logo
      integrated
      fulfillmentTypes
      address {
        street1
        street2
        city
        state
        country
        postalCode
      }
      phone
      isOpen(at: $openAt)
      nextEvents(at: $openAt) {
        open {
          ... on PharmacyOpenEvent {
            type
            datetime
          }
          ... on PharmacyCloseEvent {
            type
            datetime
          }
          ... on PharmacyOpen24HrEvent {
            type
          }
        }
        close {
          ... on PharmacyOpenEvent {
            type
            datetime
          }
          ... on PharmacyCloseEvent {
            type
            datetime
          }
          ... on PharmacyOpen24HrEvent {
            type
          }
        }
      }
      hours {
        dayOfWeek
        is24Hr
        openFrom
        openUntil
        timezone
      }
    }
    fills {
      id
      treatment {
        ... on Medication {
          id
          name
          strength
          names {
            brandName
            genericName
          }
          therapeuticClassifications {
            tc0 {
              code
              name
            }
            tc10 {
              name
              code
            }
            tc6 {
              name
              code
            }
            tc4 {
              name
              code
            }
            tc2 {
              name
              code
            }
          }
        }
        ... on MedicalEquipment {
          id
          name
          names {
            brandName
            genericName
          }
          therapeuticClassifications {
            tc0 {
              code
              name
            }
            tc10 {
              name
              code
            }
            tc6 {
              name
              code
            }
            tc4 {
              name
              code
            }
            tc2 {
              name
              code
            }
          }
        }
        ... on Compound {
          id
          name
        }
      }
      prescription {
        id
        daysSupply
        dispenseQuantity
        dispenseUnit
        dispenseAsWritten
        expirationDate
        fillsAllowed
        provider {
          id
          name {
            full
          }
        }
      }
    }
    patient {
      id
      name {
        full
      }
      dateOfBirth
      gender
      sex
      address {
        id
        street1
        street2
        city
        state
        postalCode
        country
      }
      preferredPharmacies {
        ...PharmacyFields
      }
    }
    fulfillments {
      id
      state
      exceptions {
        exceptionType
        message
        resolvedAt
      }
      patientDesiredAt
      patientDesiredByText
      pharmacyEstimatedReadyAt
      prescription {
        id
        daysSupply
        dispenseQuantity
        dispenseUnit
        expirationDate
        fillsAllowed
        treatment {
          ... on Medication {
            id
            name
            strength
          }
          ... on MedicalEquipment {
            id
            name
          }
          ... on Compound {
            id
            name
          }
        }
      }
    }
    discountCards {
      id
      prescriptionId
      price
      retailPrice
      bin
      pcn
      group
      memberId
      pharmacyId
      source
      externalUrl
    }
  }
}
    ${PharmacyFieldsFragmentDoc}`;
export const GetPharmaciesByLocationDocument = gql`
    query GetPharmaciesByLocation($location: LatLongSearch!, $limit: Int, $offset: Int, $openAt: DateTime, $is24hr: Boolean, $name: String, $includePrice: Boolean) {
  pharmaciesByLocation(
    location: $location
    limit: $limit
    offset: $offset
    openAt: $openAt
    is24hr: $is24hr
    name: $name
    includePrice: $includePrice
  ) {
    ...PharmacyFields
  }
}
    ${PharmacyFieldsFragmentDoc}`;
export const GetPharmaciesDocument = gql`
    query GetPharmacies($fulfillmentType: FulfillmentType, $integrated: Boolean, $limit: Int, $offset: Int) {
  pharmacies(
    fulfillmentType: $fulfillmentType
    integrated: $integrated
    limit: $limit
    offset: $offset
  ) {
    id
    name
    logo
    fulfillmentTypes
  }
}
    `;
export const GetInfoPageDataDocument = gql`
    query GetInfoPageData($organizationId: ID!, $pharmacyId: ID!, $openAt: DateTime) {
  me {
    name {
      full
      title
      first
      middle
      last
    }
  }
  organization(id: $organizationId) {
    id
    name
    settings {
      id
      organizationId
      brandColor
      brandLogo
      priorAuthorizationExceptionMessage
      patientUx {
        enableAutomatedOps
        enablePatientRerouting
        enablePatientDeliveryPharmacies
        patientFeaturedPharmacyName
      }
    }
  }
  pharmacy(id: $pharmacyId) {
    ...PharmacyFields
  }
}
    ${PharmacyFieldsFragmentDoc}`;
export const GetOffersForOrderDocument = gql`
    query GetOffersForOrder($orderId: ID!) {
  offers(orderId: $orderId) {
    deliveryEstimate {
      deliveryPromise
      deliveryPromiseRangeEnd
      deliveryPromiseRangeStart
    }
    cost {
      type
      amount
      amountTitle
      retailAmount
      retailAmountTitle
    }
    supplier
  }
}
    `;
export const GetOfferBundlesForOrderDocument = gql`
    query GetOfferBundlesForOrder($orderId: ID!) {
  offerBundles(orderId: $orderId) {
    aggregateCost {
      totalAmount
      totalRetailAmount
    }
    medications {
      medicationPrice {
        amount
        amountTitle
        promotions {
          type
          amount
          amountSaved
        }
        retailAmount
        retailAmountTitle
      }
      deliveryEstimate {
        deliveryPromise
      }
      prescription {
        treatment {
          id
          name
        }
      }
    }
    pricingType
    supplier
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    MarkOrderAsPickedUp(variables: MarkOrderAsPickedUpMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MarkOrderAsPickedUpMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsPickedUpMutation>({ document: MarkOrderAsPickedUpDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MarkOrderAsPickedUp', 'mutation', variables);
    },
    SetPreferredPharmacy(variables?: SetPreferredPharmacyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SetPreferredPharmacyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetPreferredPharmacyMutation>({ document: SetPreferredPharmacyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SetPreferredPharmacy', 'mutation', variables);
    },
    RerouteOrder(variables: RerouteOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RerouteOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RerouteOrderMutation>({ document: RerouteOrderDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RerouteOrder', 'mutation', variables);
    },
    SetOrderPharmacy(variables: SetOrderPharmacyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SetOrderPharmacyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetOrderPharmacyMutation>({ document: SetOrderPharmacyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SetOrderPharmacy', 'mutation', variables);
    },
    UpdatePatient(variables: UpdatePatientMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdatePatientMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePatientMutation>({ document: UpdatePatientDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdatePatient', 'mutation', variables);
    },
    UpdateOrder(variables: UpdateOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrderMutation>({ document: UpdateOrderDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateOrder', 'mutation', variables);
    },
    GetOrder(variables: GetOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrderQuery>({ document: GetOrderDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetOrder', 'query', variables);
    },
    GetPharmaciesByLocation(variables: GetPharmaciesByLocationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPharmaciesByLocationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPharmaciesByLocationQuery>({ document: GetPharmaciesByLocationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetPharmaciesByLocation', 'query', variables);
    },
    GetPharmacies(variables?: GetPharmaciesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPharmaciesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPharmaciesQuery>({ document: GetPharmaciesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetPharmacies', 'query', variables);
    },
    GetInfoPageData(variables: GetInfoPageDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetInfoPageDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetInfoPageDataQuery>({ document: GetInfoPageDataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetInfoPageData', 'query', variables);
    },
    GetOffersForOrder(variables: GetOffersForOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetOffersForOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOffersForOrderQuery>({ document: GetOffersForOrderDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetOffersForOrder', 'query', variables);
    },
    GetOfferBundlesForOrder(variables: GetOfferBundlesForOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetOfferBundlesForOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOfferBundlesForOrderQuery>({ document: GetOfferBundlesForOrderDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetOfferBundlesForOrder', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;